import {post} from "@/utils/network";
import settings from "@/views/Testing/TestingDetail/cmps/settings/settings.vue";

export function getFigureCode() {
  return post<{
    sessionid:string,
    url: string,
  }>('/UserApi/getFigureCode', )
}

export function sendCode(verify:string, mobile:string, sessionid: string,secondDomain?:string) {
  return post<void>('/UserApi/sendCode', {
    verify,
    mobile,
    sessionid,
    secondDomain
  })
}

export function sendEmailCode(verify:string, email:string, sessionid: string, type? :string) {
  return post<void>('/UserApi/sendEmailCode', {
    verify,
    email,
    sessionid,
    type,
  })
}

export function completeUserLoginInfo (
  username: string,
  school: string,
  usertype: string,
  token: any,
  verify: string,
  sessionid: string,
  stno: string
) {
  return post('/UserApi/completion', {
    username,
    school,
    usertype,
    token,
    verify,
    sessionid,
    stno,
  })
}

export function login(email: string, password: string,  code_key?:string,remember:string = '1',) {
  let selfCodeKey = window.localStorage.getItem('code_key') || code_key
  return post<{
    uid:string,
    token: string,
    isenterprise: string,
    url: string,
  }>('/UserApi/login', {
    email,
    password,
    code_key: selfCodeKey,
    remember,
    source_type :1, // 写死 来源等于1 代表移动端
  })
}

export function loginByMobile(mobile:string, code:string, remember:string = '1') {
  return post<{
    is_new: 0 | 1,
    isenterprise: 0 |1 ,
    token: string,
    uid: string,
  }>('/UserApi/loginByMobile', {
    mobile,
    code,
    remember,
    source_type :1, // 写死 来源等于1 代表移动端
  })
}

export function getSchoolList(querystring?:any) {
  return post<Array<any>>('/InformationSupplementApi/getCollegeNames', {
    search: querystring,
  })
}

export function getTokenByCode(code: string, appid: string) {
  return post<{
    "token":string,
    "code_key": string,
    "openid": string;
    "uid": string,
    "otherType":1 | 2 //1 直接登陆 2.去绑定
  }>('/UserApi/getInfoStatusByCode', {
    code,
    appid,
    source_type :1, // 写死 来源等于1 代表移动端
  })
}

export function register(data: {
  email:string
  password:string
  school: string,
  username: string,
  code: string,
  type: string,
  code_key?:string,
  stno: string,
  source_type?:number, // 来源标识符
}) {
  data.code_key = window.localStorage.getItem('code_key') || data.code_key;
  data.source_type = 1 // 写死 来源等于1 代表移动端
  return post<{
    url:string,
    token: string,
    isenterprise: string,
    uid: string,
  }>('/UserApi/register', data);
}

export function forgetPasswordByEmail (param: {
  code: string,
  email: string,
  xAuth: string,
}){
  return post<{
    uid: string,
    expires: string,
    sign: string,
    key?: string,
  }>('/UserApi/forgetPasswordByEmail', param)
}

export function forgetPasswordByMobile(param: {
  code: string,
  mobile: string,
  xAuth: string,
}) {
  return post<{
    uid: string,
    expires: string,
    sign: string,
    key?:string,
  }>('/UserApi/forgetPasswordByMobile', param)
}

export function resetPassword(param: {
  uid: string,
  password: string,
  expires: string,
  sign: string,
  key?:string,
}) {
  return post<any>('/UserApi/resetPassword', param)
}

//获取这个域名所属的学校的配置
export function getSchoolConfig(param: {school?:string,appid?:string}){
  return post<any>('/FutureV2/NoAuth/getSchoolConfig',param)
}

export default {
  getFigureCode,
  sendCode,
  login,
  loginByMobile,
  getTokenByCode,
  forgetPasswordByEmail,
  forgetPasswordByMobile,
  resetPassword,
  getSchoolConfig
}
